import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Layout from "../components/Layout/Layout";
import "../sass/BlogDetails.scss"; // Pastikan file ini ada

function PSB() {
  const history = useHistory();
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);

  const galleryImages = [
    "/images/gallery/portofolio5/1.png",
    "/images/gallery/portofolio5/2.png",
    "/images/gallery/portofolio5/3.png",
    "/images/gallery/portofolio5/4.png",
    "/images/gallery/portofolio5/5.png",
     "/images/gallery/portofolio5/6.png",
  ];

  const handleImageClick = (img, index) => {
    setSelectedImage(img);
    setCurrentIndex(index);
  };

  const handlePrev = () => {
    const newIndex =
      (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    setCurrentIndex(newIndex);
    setSelectedImage(galleryImages[newIndex]);
  };

  const handleNext = () => {
    const newIndex = (currentIndex + 1) % galleryImages.length;
    setCurrentIndex(newIndex);
    setSelectedImage(galleryImages[newIndex]);
  };

  const handleClosePreview = () => setSelectedImage(null);

  // Creator dan Tools bisa juga diatur dari props atau markdown jika diinginkan
  const creator = "Lutfi Riani";
  const tools = "Figma";

  return (
    <Layout>
      <section className="blog-gallery">
        <div className="gallery-header">
          <button
            type="button"
            className="gallery-back-button"
            onClick={() => history.goBack()}
          >
            <i className="icon-arrow-left"></i> Kembali
          </button>
          <h2 className="gallery-title">Galeri Portofolio</h2>
        </div>

        {/* Informasi Creator dan Tools */}
        <ul className="list-inline portfolio-info mt-0 mb-4">
          <li className="list-inline-item">
            <i className="icon-user"></i> Creator: {creator}
          </li>
          <li className="list-inline-item">
            <i className="icon-tools"></i> Tools: {tools}
          </li>
        </ul>

        <div className="gallery-grid">
          {galleryImages.map((img, index) => (
            <div
              key={index}
              className="gallery-item"
              onClick={() => handleImageClick(img, index)}
            >
              <img
                src={img}
                alt={`gallery-${index}`}
                className="gallery-image"
              />
            </div>
          ))}
        </div>

        {selectedImage && (
          <div className="modal-overlay" onClick={handleClosePreview}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button onClick={handleClosePreview} className="modal-close">
                &times;
              </button>
              <button onClick={handlePrev} className="modal-nav-button prev">
                &#10094;
              </button>
              <img src={selectedImage} alt="Preview" className="modal-image" />
              <button onClick={handleNext} className="modal-nav-button next">
                &#10095;
              </button>
            </div>
          </div>
        )}
      </section>
    </Layout>
  );
}

export default PSB;
